'use client';
import { ArticleCard } from '@/sanity/fetchArticles';
import { EventCard } from '@/sanity/fetchEvents';
import { useState } from 'react';
import TabButton from '../base/TabButton';
import ArticlesGrid from './ArticlesGrid';
import EventsGrid from './EventsGrid';
import { EmptyList } from '../base/EmptyList';
import layoutStyles from '@/styles/section-layouts.module.scss';
import styles from './ArticlesAndEventsTabs.module.scss';
import {
  EMPTY_EVENTS_TEXT,
  EMPTY_GUIDES_TEXT,
  URL_PATH_CATEGORY,
} from '@/shared/constants';

interface ArticlesAndEventsTabsProps {
  articles: ArticleCard[];
  events: EventCard[];
  categoryId: string;
  categorySlug: string;
}

export default function ArticlesAndEventsTabs({
  articles,
  events,
  categoryId,
  categorySlug,
}: ArticlesAndEventsTabsProps) {
  const [currentTab, setCurrentTab] = useState(0);
  const tabs = ['Guides', 'Events'];

  return (
    <div className={styles.wrapper}>
      <div className={[layoutStyles.containerContent, styles.tabRow].join(' ')}>
        {tabs.map((tab, index) => {
          return (
            <TabButton
              tab={tab}
              index={index}
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
              key={tab}
            />
          );
        })}
      </div>

      <div className={layoutStyles.containerContent}>
        <div className={styles.divider} />
      </div>

      <div className={[layoutStyles.containerContent, styles.contentArea].join(' ')}>
        {currentTab === 0 ? (
          articles.length > 0 ? (
            <ArticlesGrid
              key={categoryId}
              articles={articles}
              categoryLink={`/${URL_PATH_CATEGORY}/${categorySlug}`}
              title={tabs[currentTab]}
              variant={'normal'}
              showHeader={false}
              mobileView="vertical"
              limit={6}
              showBottomLoadMore={true}
              className={styles.articlesGrid}
            />
          ) : (
            <EmptyList
              buttonText="Zu den Events"
              description={EMPTY_GUIDES_TEXT}
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
            />
          )
        ) : events.length > 0 ? (
          <div className={styles.eventsWrapper}>
            <EventsGrid events={events} />
          </div>
        ) : (
          <EmptyList
            buttonText="Zu den Guides"
            description={EMPTY_EVENTS_TEXT}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
        )}
      </div>
    </div>
  );
}
